// extracted by mini-css-extract-plugin
module.exports = {"MobileCta":"GlobalPageHeader_MobileCta__2_UOl","alignWithMenu":"GlobalPageHeader_alignWithMenu__qaZdZ"};